import React from 'react'
import classnames from 'classnames'
import HTMLReactParser from 'html-react-parser'

const SectionHeading = ({
    title,
    subtitle,
    subheading,
    thirdHeading,
    className,
    titleCss = '',
}) => {
    return (
        <div className={classnames('flex flex-col gap-y-1 py-5', className)}>
            {title && (
                <h3 className={classnames('text-xl font-semibold', titleCss)}>
                    {title}
                </h3>
            )}
            {subheading && (
                <div className="flex items-center gap-1">{subheading}</div>
            )}
            {typeof subtitle === 'string' ? (
                <p className="text-sm font-normal">
                    {HTMLReactParser(subtitle || '')}
                </p>
            ) : (
                subtitle
            )}
            {thirdHeading && (
                <div className="flex items-center gap-1">
                    {thirdHeading.title && (
                        <h3 className="font-semibold text-sm text-black">
                            {thirdHeading.title}
                        </h3>
                    )}
                    <p className="font-normal text-sm ">
                        {thirdHeading.subheading}
                    </p>
                </div>
            )}
        </div>
    )
}

export default SectionHeading
